import React from "react";
import { Fragment } from "react/cjs/react.production.min";
import "./footer.css";

const Foot = () => {
  return (
    <Fragment>
      <div className="credits">
        <h3 className="end">Created by Priyansh_Gupta_</h3>
      </div>
    </Fragment>
  );
};

export default Foot;
